import { render, staticRenderFns } from "./QxTop.vue?vue&type=template&id=7880dc7b&scoped=true"
import script from "./QxTop.vue?vue&type=script&lang=js"
export * from "./QxTop.vue?vue&type=script&lang=js"
import style0 from "./QxTop.vue?vue&type=style&index=0&id=7880dc7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7880dc7b",
  null
  
)

export default component.exports